import React from "react";
import style from "./style.module.css";

function index({ data, lang }) {
  return (
    <div className={style.container}>
      {data
        ? data.map((item, key) => {
            return (
              <div key={key} className={style.element}>
                <h1 className={style.title}>{item.title[lang]}</h1>
                <div
                  className={style.btnContainer}
                  data-tracking="click"
                  data-value=""
                >
                  <a className={style.button} href={item.button_link}>
                    {item.button_text ? item.button_text[lang] : ""}
                  </a>
                </div>
              </div>
            );
          })
        : null}
    </div>
  );
}

export default index;
